import { render, staticRenderFns } from "./AcgihTable.vue?vue&type=template&id=868675f2&scoped=true"
import script from "./AcgihTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./AcgihTable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868675f2",
  null
  
)

export default component.exports